import React, { useState } from 'react'; // Add useState import
import styles from './Logistic.module.css';
import backgroundImage from '../../Images/I71.png'; // Import from images folder
import Thealth2 from '../../Images/T6.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';

import iconT44 from '../../Images/icon45.png'; 
import iconT45 from '../../Images/icon46.png'; 
import iconT46 from '../../Images/icon47.png'; 
import iconT47 from '../../Images/icon48.png'; 
import iconT48 from '../../Images/icon50.png'; 

import Icon71 from '../../Images/icon81.png';
import icon72 from '../../Images/icon82.png';
import icon73 from '../../Images/icon87.png';
import icon74 from '../../Images/icon88.png';
import icon75 from '../../Images/icon89.png';
import icon76 from '../../Images/icon90.png';

import Ibg71 from '../../Images/Ibg71.png';


import iconT76 from '../../Images/iconT71.png';
import iconT77 from '../../Images/iconT72.png';
import iconT78 from '../../Images/iconT73.png';



import uicon1 from '../../Images/uicon1.png';
import uicon2 from '../../Images/uicon2.png';
import uicon3 from '../../Images/uicon3.png';
import uicon4 from '../../Images/uicon4.png';


import uicon5 from '../../Images/uicon5.png';
import uicon6 from '../../Images/uicon6.png';
import uicon7 from '../../Images/uicon3.png';

import uicon8 from '../../Images/uicon7.png';
import uicon9 from '../../Images/uicon8.png';
import uicon10 from '../../Images/uicon9.png';
import uicon11 from '../../Images/uicon10.png';


import uicon12 from '../../Images/uicon11.png';
import uicon13 from '../../Images/uicon12.png';
import uicon14 from '../../Images/uicon13.png';


import uicon15 from '../../Images/uicon14.png';
import uicon16 from '../../Images/uicon15.png';
import uicon17 from '../../Images/uicon16.png';
import uicon18 from '../../Images/uicon17.png';


import uicon19 from '../../Images/uicon19.png';
import uicon20 from '../../Images/uicon20.png';
import uicon21 from '../../Images/uicon21.png';
import uicon22 from '../../Images/uicon22.png';


import T56 from '../../Images/T60.png'; 
import T57 from '../../Images/T57.png';
import T58 from '../../Images/T61.png';
import T59 from '../../Images/T59.png';

import T66 from '../../Images/T66.png';
import T67 from '../../Images/T67.png';

import iconT49 from '../../Images/icon77.png'; 

import icon1 from '../../Images/icon1.png';
import icon2 from '../../Images/icon2.png';
import icon3 from '../../Images/icon3.png';
import icon4 from '../../Images/icon4.png';
import bT1 from '../../Images/I73.png';
import bT2 from '../../Images/I74.png';
import bT3 from '../../Images/I75.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const Logistic = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };




// FAQ Section State and Data
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };  

  const faqs = [
    {
      question: "How does ToxBox ensure compliance with customs regulations?",
      answer: "Our AI-powered compliance engine continuously monitors regulations across 150+ countries and automatically validates all shipment documentation against current requirements. We provide real-time alerts for any compliance issues and suggest corrections before submission."
    },
    {
      question: "What shipping methods and carriers do you support?",
      answer: "ToxBox integrates with 500+ carriers worldwide, including DHL, FedEx, UPS, Maersk, and regional specialists. We support air freight, ocean freight (FCL/LCL), ground transportation, and express delivery services with real-time rate comparison."
    },
    {
      question: "Can I track multiple shipments from different carriers?",
      answer: "Yes! Our unified dashboard provides real-time tracking for all your shipments regardless of carrier. You'll receive automated notifications for key milestones, delays, and delivery confirmations, all in one place."
    },
    {
      question: "How quickly can I get started with ToxBox?",
      answer: "Most businesses are fully operational within 24 hours. Our onboarding includes automated account setup, carrier integration, and a dedicated specialist to help configure your shipping preferences and compliance requirements."
    },
    {
      question: "What kind of support do you offer?",
      answer: "We provide 24/7 support through live chat, email, and phone. Every account includes access to certified customs brokers and logistics experts. Enterprise customers receive a dedicated account manager and priority support."
    },
    {
      question: "Is my shipping data secure?",
      answer: "Absolutely. We use bank-level encryption (AES-256) for all data, maintain SOC 2 Type II compliance, and undergo regular security audits. Your shipping information is never shared with third parties without explicit consent."
    }
  ];





  return (
     <div className={styles.logistically88}>
  {/* Hero Section */}
  <section className={styles.heroSection88}>
    <div className={styles.container88}>
      {/* 🚀 Revolutionizing Global Logistics - Top Center */}
      <div className={styles.globalTag88}>
        🚀 Revolutionizing Global Logistics
      </div>

      {/* Definition Tackel / Addressing Problems */}
      <div className={styles.titleWrapper88}>
        <h1 className={styles.mainTitle88}>Definition Tackel</h1>
        <h2 className={styles.subTitle88}>Addressing Problems</h2>
      </div>

      {/* Description */}
      <p className={styles.description88}>
        Navigate the complexities of international shipping with our AI-powered platform. 
        From customs clearance to real-time tracking, we handle every detail so you can 
        focus on growing your business.
      </p>

      {/* Buttons */}
      <div className={styles.buttonGroup88}>
        <button className={`${styles.button88} ${styles.primaryButton88}`}>
          Get Started
        </button>
        <button className={`${styles.button88} ${styles.secondaryButton88}`}>
          Learn More
        </button>
      </div>

      {/* Stats Grid - 4 Column Layout */}
      <div className={styles.statsGrid88}>
        <div className={styles.statItem88}>
          <div className={styles.statNumber88}>45%</div>
          <div className={styles.statLabel88}>Faster Customs Clearance</div>
        </div>
        <div className={styles.statItem88}>
          <div className={styles.statNumber88}>99%</div>
          <div className={styles.statLabel88}>Documentation Accuracy</div>
        </div>
        <div className={styles.statItem88}>
          <div className={styles.statNumber88}>60%</div>
          <div className={styles.statLabel88}>Cost Reduction</div>
        </div>
        <div className={styles.statItem88}>
          <div className={styles.statNumber88}>24/7</div>
          <div className={styles.statLabel88}>Real-time Support</div>
        </div>
      </div>
    </div>
  </section>














{/* Why Toxbox Logistics? logistically89 */}
<div className={styles.logistically89}>
  {/* Hero Section */}
  <section className={styles.heroSection89}>
    <div className={styles.container89}>
      {/* Header Section */}
      <div className={styles.header89}>
        <h1 className={styles.mainTitle89}>Why Toxbox Logistics?</h1>
        <p className={styles.subtitle89}>
          Transform your supply chain with intelligent automation and expert support
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid89}>
        {/* Card 1: Regulatory Compliance Made Simple */}
        <div className={styles.card89}>
          <div className={styles.iconBox89}>
            <img 
              src={uicon1} 
              alt="Regulatory Compliance"
              className={styles.cardIcon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Regulatory Compliance Made Simple</h3>
          <p className={styles.cardDescription89}>
            Our AI-powered system automatically checks and validates all shipments against current international trade regulations, ensuring 100% compliance across 150+ countries.
          </p>
        </div>

        {/* Card 2: Real-Time Supply Chain Visibility */}
        <div className={styles.card89}>
          <div className={styles.iconBox89}>
            <img 
              src={uicon2} 
              alt="Real-Time Visibility"
              className={styles.cardIcon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Real-Time Supply Chain Visibility</h3>
          <p className={styles.cardDescription89}>
            Track every shipment with precision GPS tracking, automated customs updates, and predictive delivery estimates. Get instant alerts for any delays or issues.
          </p>
        </div>

        {/* Card 3: Global Network Integration */}
        <div className={styles.card89}>
          <div className={styles.iconBox89}>
            <img 
              src={uicon3} 
              alt="Global Network Integration"
              className={styles.cardIcon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Global Network Integration</h3>
          <p className={styles.cardDescription89}>
            Seamlessly connect with carriers, warehouses, and customs authorities worldwide. Our platform integrates with 500+ logistics partners for complete coverage.
          </p>
        </div>

        {/* Card 4: Dedicated Logistics Experts */}
        <div className={styles.card89}>
          <div className={styles.iconBox89}>
            <img 
              src={uicon4} 
              alt="Dedicated Logistics Experts"
              className={styles.cardIcon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Dedicated Logistics Experts</h3>
          <p className={styles.cardDescription89}>
            24/7 access to certified customs brokers and logistics specialists. Get personalized support for complex shipments and regulatory questions.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>













{/* AI Agents for Modern Logistics stream90  */}
<div className={styles.stream90}>
  {/* Hero Section */}
  <section className={styles.heroSection90}>
    <div className={styles.container90}>
      {/* Header Section */}
      <div className={styles.header90}>
        <h1 className={styles.mainTitle90}>AI Agents for Modern Logistics</h1>
        <p className={styles.subtitle90}>
          Harness the power of intelligent automation with our specialized AI agents
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid90}>
        {/* Card 1: Compliance Agent */}
        <div className={styles.card90}>
          <div className={styles.iconBox90}>
            <img 
              src={uicon5} 
              alt="Compliance Agent"
              className={styles.cardIcon90}
            />
          </div>
          <h3 className={styles.cardTitle90}>Compliance Agent</h3>
          <p className={styles.cardDescription90}>
            Automatically ensures all documentation meets international trade regulations and compliance standards
          </p>
        </div>

        {/* Card 2: Documentation Agent */}
        <div className={styles.card90}>
          <div className={styles.iconBox90}>
            <img 
              src={uicon6}
              alt="Documentation Agent"
              className={styles.cardIcon90}
            />
          </div>
          <h3 className={styles.cardTitle90}>Documentation Agent</h3>
          <p className={styles.cardDescription90}>
            Generates, validates, and processes shipping documents with 99.9% accuracy
          </p>
        </div>

        {/* Card 3: Route Optimization Agent */}
        <div className={styles.card90}>
          <div className={styles.iconBox90}>
            <img 
              src={uicon7} 
              alt="Route Optimization Agent"
              className={styles.cardIcon90}
            />
          </div>
          <h3 className={styles.cardTitle90}>Route Optimization Agent</h3>
          <p className={styles.cardDescription90}>
            Analyzes global shipping routes to find the most cost-effective and timely delivery options
          </p>
        </div>
      </div>
    </div>
  </section>
</div>











{/* ToxBox vs Traditional Logistics valid91*/}
<div className={styles.valid91}>
  {/* Hero Section */}
  <section className={styles.heroSection91}>
    <div className={styles.container91}>
      {/* Header Section */}
      <div className={styles.header91}>
        <h1 className={styles.mainTitle91}>ToxBox vs Traditional Logistics</h1>
        <p className={styles.subtitle91}>
          See how we stack up against conventional freight forwarding services
        </p>
      </div>

      {/* Comparison Table */}
      <div className={styles.tableWrapper91}>
        <table className={styles.comparisonTable91}>
          {/* Header Row */}
          <thead>
            <tr className={styles.headerRow91}>
              <th className={`${styles.tableHeader91} ${styles.featureHeader91}`}></th>
              <th className={`${styles.tableHeader91} ${styles.toxboxHeader91}`}>ToxBox</th>
              <th className={`${styles.tableHeader91} ${styles.traditionalHeader91}`}>Traditional</th>
            </tr>
          </thead>
          
          {/* Table Body */}
          <tbody>
            {/* Row 1: Automated Customs Documentation */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Automated Customs Documentation</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>

            {/* Row 2: Real-time Shipment Tracking */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Real-time Shipment Tracking</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
            </tr>

            {/* Row 3: AI-Powered Route Optimization */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>AI-Powered Route Optimization</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>

            {/* Row 4: Compliance Risk Assessment */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Compliance Risk Assessment</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>

            {/* Row 5: Multi-carrier Integration */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Multi-carrier Integration</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
            </tr>

            {/* Row 6: Predictive Delivery Analytics */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Predictive Delivery Analytics</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>

            {/* Row 7: 24/7 Expert Support */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>24/7 Expert Support</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>

            {/* Row 8: Carbon Footprint Tracking */}
            <tr className={styles.tableRow91}>
              <td className={styles.featureCell91}>Carbon Footprint Tracking</td>
              <td className={`${styles.iconCell91} ${styles.toxboxCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.checkIcon91}`}>
                  <span className={styles.checkSign91}>✓</span>
                </div>
              </td>
              <td className={`${styles.iconCell91} ${styles.traditionalCell91}`}>
                <div className={`${styles.iconWrapper91} ${styles.crossIcon91}`}>
                  <span className={styles.crossSign91}>✕</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>













{/* Solutions Across the Supply Chain agrement92 */}
<div className={styles.agrement92}>
  {/* Hero Section */}
  <section className={styles.heroSection92}>
    <div className={styles.container92}>
      {/* Header Section */}
      <div className={styles.header92}>
        <h1 className={styles.mainTitle92}>Solutions Across the Supply Chain</h1>
        <p className={styles.subtitle92}>
          Comprehensive logistics services tailored to your business needs
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid92}>
        {/* Card 1: E-commerce Solutions */}
        <div className={styles.card92}>
          <div className={styles.iconBox92}>
            <img 
              src={uicon8}
              alt="E-commerce Solutions"
              className={styles.cardIcon92}
            />
          </div>
          <h3 className={styles.cardTitle92}>E-commerce Solutions</h3>
          <p className={styles.cardDescription92}>
            Streamline international shipping for online retailers with automated customs clearance and multi-carrier options
          </p>
          <div className={styles.bulletList92}>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Bulk label generation</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Returns management</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Inventory sync</span>
            </div>
          </div>
        </div>

        {/* Card 2: Land Freight */}
        <div className={styles.card92}>
          <div className={styles.iconBox92}>
            <img 
              src={uicon9} 
              alt="Land Freight"
              className={styles.cardIcon92}
            />
          </div>
          <h3 className={styles.cardTitle92}>Land Freight</h3>
          <p className={styles.cardDescription92}>
            Optimize ground transportation across borders with real-time tracking and compliance automation
          </p>
          <div className={styles.bulletList92}>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Cross-border trucking</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>LTL & FTL options</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Route optimization</span>
            </div>
          </div>
        </div>

        {/* Card 3: Ocean Freight */}
        <div className={styles.card92}>
          <div className={styles.iconBox92}>
            <img 
              src={uicon10} 
              alt="Ocean Freight"
              className={styles.cardIcon92}
            />
          </div>
          <h3 className={styles.cardTitle92}>Ocean Freight</h3>
          <p className={styles.cardDescription92}>
            Manage container shipments with complete visibility from port to destination
          </p>
          <div className={styles.bulletList92}>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>FCL & LCL shipping</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Port scheduling</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Bill of lading automation</span>
            </div>
          </div>
        </div>

        {/* Card 4: Air Cargo */}
        <div className={styles.card92}>
          <div className={styles.iconBox92}>
            <img 
              src={uicon11} 
              alt="Air Cargo"
              className={styles.cardIcon92}
            />
          </div>
          <h3 className={styles.cardTitle92}>Air Cargo</h3>
          <p className={styles.cardDescription92}>
            Fast international delivery with priority handling and expedited customs processing
          </p>
          <div className={styles.bulletList92}>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Express shipping</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Dangerous goods</span>
            </div>
            <div className={styles.bulletItem92}>
              <span className={styles.bullet92}>•</span>
              <span className={styles.bulletText92}>Temperature control</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>











{/* All Essential Requirements Covered extreme93 */}
<div className={styles.extreme93}>
  {/* Hero Section */}
  <section className={styles.heroSection93}>
    <div className={styles.container93}>
      {/* Header Section */}
      <div className={styles.header93}>
        <h1 className={styles.mainTitle93}>All Essential Requirements Covered</h1>
        <p className={styles.subtitle93}>
          We handle the complexities so you don't have to worry about missing documentation
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid93}>
        {/* Card 1: All Required Documentation */}
        <div className={styles.card93}>
          <div className={styles.iconBox93}>
            <img 
              src={uicon12} 
              alt="All Required Documentation"
              className={styles.cardIcon93}
            />
          </div>
          <h3 className={styles.cardTitle93}>All Required Documentation</h3>
          <div className={styles.listContainer93}>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Commercial Invoice</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Packing List</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Certificate of Origin</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Customs Declaration</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Bill of Lading/Airway Bill</span>
            </div>
          </div>
        </div>

        {/* Card 2: Payment & Insurance */}
        <div className={styles.card93}>
          <div className={styles.iconBox93}>
            <img 
              src={uicon13} 
              alt="Payment & Insurance"
              className={styles.cardIcon93}
            />
          </div>
          <h3 className={styles.cardTitle93}>Payment & Insurance</h3>
          <div className={styles.listContainer93}>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Letter of Credit</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Cargo Insurance</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Payment Terms Setup</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Currency Conversion</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Duty & Tax Calculator</span>
            </div>
          </div>
        </div>

        {/* Card 3: Compliance & Licensing */}
        <div className={styles.card93}>
          <div className={styles.iconBox93}>
            <img 
              src={uicon14} 
              alt="Compliance & Licensing"
              className={styles.cardIcon93}
            />
          </div>
          <h3 className={styles.cardTitle93}>Compliance & Licensing</h3>
          <div className={styles.listContainer93}>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Import/Export License</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Harmonized System Codes</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Regulatory Approvals</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Sanctions Screening</span>
            </div>
            <div className={styles.listItem93}>
              <div className={styles.tickCircle93}>
                <span className={styles.tickMark93}>✓</span>
              </div>
              <span className={styles.listText93}>Trade Agreement Verification</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>















{/* Navigate Easily through Platform intimate94 */}
<div className={styles.intimate94}>
  {/* Hero Section */}
  <section className={styles.heroSection94}>
    <div className={styles.container94}>
      {/* Header Section */}
      <div className={styles.header94}>
        <h1 className={styles.mainTitle94}>Navigate Easily through Platform</h1>
        <p className={styles.subtitle94}>
          Get the help you need, when you need it, with our comprehensive support resources
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid94}>
        {/* Card 1: Knowledge Base */}
        <div className={styles.card94}>
          <div className={styles.cardHeader94}>
            <div className={styles.iconBox94}>
              <img 
                src={uicon15}
                alt="Knowledge Base"
                className={styles.cardIcon94}
              />
            </div>
            <h3 className={styles.cardTitle94}>Knowledge Base</h3>
          </div>
          <p className={styles.cardDescription94}>
            Comprehensive guides covering customs regulations, shipping procedures, and best practices for international trade
          </p>
          <a href="#" className={styles.cardLink94}>
            Browse Articles →
          </a>
        </div>

        {/* Card 2: Video Tutorials */}
        <div className={styles.card94}>
          <div className={styles.cardHeader94}>
            <div className={styles.iconBox94}>
              <img 
                src={uicon16} 
                alt="Video Tutorials"
                className={styles.cardIcon94}
              />
            </div>
            <h3 className={styles.cardTitle94}>Video Tutorials</h3>
          </div>
          <p className={styles.cardDescription94}>
            Step-by-step walkthrough videos showing how to create shipments, track packages, and use advanced features
          </p>
          <a href="#" className={styles.cardLink94}>
            Watch Now →
          </a>
        </div>

        {/* Card 3: Live Chat Support */}
        <div className={styles.card94}>
          <div className={styles.cardHeader94}>
            <div className={styles.iconBox94}>
              <img 
                src={uicon17} 
                alt="Live Chat Support"
                className={styles.cardIcon94}
              />
            </div>
            <h3 className={styles.cardTitle94}>Live Chat Support</h3>
          </div>
          <p className={styles.cardDescription94}>
            Connect instantly with our logistics experts for real-time assistance with your shipments and questions
          </p>
          <a href="#" className={styles.cardLink94}>
            Start Chat →
          </a>
        </div>

        {/* Card 4: Community Forum */}
        <div className={styles.card94}>
          <div className={styles.cardHeader94}>
            <div className={styles.iconBox94}>
              <img 
                src={uicon18} 
                alt="Community Forum"
                className={styles.cardIcon94}
              />
            </div>
            <h3 className={styles.cardTitle94}>Community Forum</h3>
          </div>
          <p className={styles.cardDescription94}>
            Join thousands of shippers sharing tips, experiences, and solutions to common logistics challenges
          </p>
          <a href="#" className={styles.cardLink94}>
            Join Community →
          </a>
        </div>
      </div>
    </div>
  </section>
</div>














 {/* Value and Recognition Awards recognise95 */}
<div className={styles.recognise95}>
  {/* Hero Section */}
  <section className={styles.heroSection95}>
    <div className={styles.container95}>
      {/* Header Section */}
      <div className={styles.header95}>
        <h1 className={styles.mainTitle95}>Value and Recognition Awards</h1>
        <p className={styles.subtitle95}>
          Trusted by industry leaders and recognized globally for excellence
        </p>
      </div>

      {/* Cards Grid */}
      <div className={styles.cardsGrid95}>
        {/* Card 1: Best SaaS Product */}
        <div className={styles.card95}>
          <div className={styles.iconCircle95}>
            <img 
              src={uicon19} 
              alt="Best SaaS Product"
              className={styles.cardIcon95}
            />
          </div>
          <h3 className={styles.cardTitle95}>Best SaaS Product</h3>
          <div className={styles.awardName95}>Tech Innovation Awards 2025</div>
          <p className={styles.cardDescription95}>
            Recognized for revolutionizing logistics technology
          </p>
        </div>

        {/* Card 2: Top Rated Platform */}
        <div className={styles.card95}>
          <div className={styles.iconCircle95}>
            <img 
              src={uicon20} 
              alt="Top Rated Platform"
              className={styles.cardIcon95}
            />
          </div>
          <h3 className={styles.cardTitle95}>Top Rated Platform</h3>
          <div className={styles.awardName95}>G2 Customer Reviews</div>
          <p className={styles.cardDescription95}>
            4.9/5 stars from 2,500+ verified users
          </p>
        </div>

        {/* Card 3: Innovation Leader */}
        <div className={styles.card95}>
          <div className={styles.iconCircle95}> 
            <img 
              src={uicon21} 
              alt="Innovation Leader"
              className={styles.cardIcon95}
            />
          </div>
          <h3 className={styles.cardTitle95}>Innovation Leader</h3>
          <div className={styles.awardName95}>Supply Chain Excellence</div>
          <p className={styles.cardDescription95}>
            Outstanding achievement in AI-powered logistics
          </p>
        </div>

        {/* Card 4: Customer Choice */}
        <div className={styles.card95}>
          <div className={styles.iconCircle95}>
            <img 
              src={uicon22}
              alt="Customer Choice"
              className={styles.cardIcon95}
            />
          </div>
          <h3 className={styles.cardTitle95}>Customer Choice</h3>
          <div className={styles.awardName95}>Logistics Tech Summit</div>
          <p className={styles.cardDescription95}>
            Voted #1 by enterprise customers worldwide
          </p>
        </div>
      </div>
    </div>
  </section>
</div>












{/* Frequently Asked Questions - Construct96 */}
<section className={styles.Construct96}>
  <div className={styles.container96}>
    {/* Header */}
    <div className={styles.header96}>
      <h2 className={styles.title96}>Frequently Asked Questions</h2>
    </div>

    {/* FAQ Items */}
    <div className={styles.faqContainer96}>
      {faqs.map((faq, index) => (
        <div 
          key={index} 
          className={`${styles.faqItem96} ${openIndex === index ? styles.active96 : ''}`}
        >
          <div 
            className={styles.faqQuestion96} 
            onClick={() => toggleFAQ(index)}
          >
            <span className={styles.questionText96}>{faq.question}</span>
            <span className={styles.arrowIcon96}>
              {openIndex === index ? '▲' : '▼'}
            </span>
          </div>
          
          {openIndex === index && (
            <div className={styles.faqAnswer96}>
              <p className={styles.answerText96}>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</section>












<div className={styles.intensive97}>
  {/* Hero Section */}
  <section className={styles.heroSection97}>
    <div className={styles.container97}>
      {/* Single Card at Center */}
      <div className={styles.card97}>
        <h2 className={styles.title97}>Still have Questions?</h2>
        <p className={styles.description97}>
          Our logistics experts are ready to help you streamline your supply chain
        </p>
        <button className={styles.button97}>
          Contact Us
        </button>
      </div>
    </div>
  </section>
</div>




























      
    </div>
  );
};

export default Logistic;
